import { render, staticRenderFns } from "./HotelResults.vue?vue&type=template&id=213d97e9&scoped=true"
import script from "./HotelResults.vue?vue&type=script&lang=js"
export * from "./HotelResults.vue?vue&type=script&lang=js"
import style0 from "./HotelResults.vue?vue&type=style&index=0&id=213d97e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d97e9",
  null
  
)

export default component.exports